const marketRouter = [
  {
    path: 'market-module-box',
    name: 'MarketModuleBox',
    component: () => import('@/views/wxapp/bulletin-board/management/factor-bar'),
    meta: {
      title: '市场看板'
    },
    children: [
      {
        path: 'market-module',
        name: 'MarketModule',
        component: () => import('@/views/wxapp/bulletin-board/market-module/market/index'),
        meta: {
          title: '市场集团总看板'
        }
      },
      {
        path: 'business-kanban',
        name: 'BusinessKanban',
        component: () => import('@/views/wxapp/bulletin-board/market-module/business-kanban/index'),
        meta: {
          title: ''
        }
      },
      {
        path: 'market-cost',
        name: 'MarketCost',
        component: () => import('@/views/wxapp/bulletin-board/market-module/market-const/index'),
        meta: {
          title: '线上看板'
        }
      },
      {
        path: 'cost-details',
        name: 'CostDetails',
        component: () => import('@/views/wxapp/bulletin-board/market-module/market/cost-details/index'),
        meta: {
          title: '费用'
        }
      },
      {
        path: 'market-enabling',
        name: 'MarketEnabling',
        component: () => import('@/views/wxapp/bulletin-board/market-module/market-enabling/index'),
        meta: {
          title: '营收'
        }
      }
    ]
  },
  {
    path: 'market-business',
    name: 'MarketBusiness',
    component: () => import('@/views/wxapp/bulletin-board/market-module/market-business/index'),
    meta: {
      title: '省体事业部'
    }
  }
]

export default marketRouter
